import { useLocation } from 'react-router-dom';
import pages from '../../data/page-seo.json';
import assets from '../../data/performance-assets.json';
export const isModernRoute = path => /^\/(?:consult-an-expert|talk-to-a-(?:lawyer|chartered-accountant|company-secretary)|lawyer-services(?:\/[^/]+)?|hire-fractional-legal-consultant)\/?$/.test(path);
function ensureLegacyStyles() {
  if (window.__biatLegacyCss?.ready) return;
  if (!window.__biatLegacyCss) {
    const link = document.createElement('link');
    link.id = 'biat-legacy-css';
    link.rel = 'stylesheet';
    link.href = window.__biatLegacyCssUrl || assets.legacy.url;
    window.__biatLegacyCss = { ready: false, promise: new Promise(resolve => {
      link.onload = link.onerror = () => { window.__biatLegacyCss.ready = true; resolve(); };
    }) };
    document.head.appendChild(link);
  }
  throw window.__biatLegacyCss.promise;
}
export default function RouteStyles({ children }) {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '') || '/';
  if (pages[path] && !isModernRoute(path) && typeof document !== 'undefined') ensureLegacyStyles();
  return children;
}
